export default {
  LIST_FETCHED: 'NEWS_FETCHED',
  LIST_LOAD: 'NEWS_LOAD',
  ITEM_DETAIL: 'NEWS_DETAIL',
  BUTTON_LOAD: 'NEWS_BUTTON_LOAD',
};
